import { render, staticRenderFns } from "./IconArrowForward.vue?vue&type=template&id=63397f36&"
import script from "./IconArrowForward.vue?vue&type=script&lang=js&"
export * from "./IconArrowForward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports